<template>
     <div class="inquiry_main">
        <p class="current">当前位置：<span>我的询价</span></p>
        <div class="inquiry_info"> 
            <div class="vstips"  v-if="total <= 0">
                <p>亲，未找到记录~</p>
            </div>
            <div v-for="(item,index) in vsData" :key="index" class="vsList-normal">
				<div class="vstitle">
					<p class="vstext vsflexone">单号：{{item.order_no}}</p>
				
					<p class="vsintro">时间：{{item.create_time}}</p>
				</div>
				<div class="vsorderitems" v-for="(sitem,sindex) in item.order_items" :key="sindex">
					<div class="vsimgcon">
						<div class="vsimgcover vsimg" :style="{'background-image':'url('+sitem.firstFile.FileUrl+')'}"></div>
					</div>
					<div class="vsorderitemsInfo vsflexone">
						<div class="vspname">
							<div>{{sitem.product_name}}</div>
							<div class="gray" v-if="!(sitem.atts_items_names == '')">
								{{sitem.atts_items_names}}
							</div>							
						</div>
						<div class="vsflexone"></div>
						<div class="vsprice vsflex">
							<div class="vsflexone">
								<text class="price">{{sitem.price}}</text>&nbsp;&nbsp;<text> x {{sitem.amount}}</text>
							</div>
							<!-- <div v-if="(item.isconfirm=='1')&&(sitem.isremark=='0')" @click="remark(index,item.order_no,sitem.id,sitem.product_id)" class="vsbtn2">评价</div>
							<div v-if="(item.isconfirm=='1')&&(sitem.isremark=='1')" @click="remark(index,item.order_no,sitem.id,sitem.product_id)" class="vsbtn2">已评价</div> -->
						</div>
					</div>
				</div>
				<div class="vsflags vsflex">
                    <el-button type="primary" @click="allUrlToX(1,item.id)" size="small"> 详情 </el-button>
                    <el-button type="primary" @click="allUrlToX(2,item.id)" size="small"> 报价 </el-button>
				</div>
			</div>
            <div class="pagination">
                <el-pagination
                    :hide-on-single-page="hideOnSinglePage"
                    :page-size="20"
                    :pager-count="11"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getTimeDate } from '@/js/getTime'

export default{
    data(){
        return{
            vsurl:'',
            vstoken:'',
            vspn:0,
            vsData:[],
            pageNum: 1,
            pageSize: 10,
            dian:true,
            xiao:false,
            ma:false,
            isused:'0',
            isexpired:'0',
            curTabIndex:0,
            tabData:[{'item':'直推','value':'1'},{'item':'间推','value':'2'}],
            xlevel:'1',
            UserTotal1:0,
            alltotal:0,
            total: 0,
            windowTop: 0,
            vsHeight: 0,
            statusBarHeight: 0,
            topHeight: 0,
            scrollHeight: 0,
            hideOnSinglePage: true
        }
    },
    methods: {
        GetList(data) {
      
          
            this.$store.dispatch('enable/getInquiryList',data)
                .then(res =>{
                    if(res.ok){
                        var resdata = res.data
                        var items = res.data.items
                        this.total = resdata.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                        var dpn = items.length
                        if(dpn > 0){
                            for(var i=0;i<dpn;i++){
                                var item = items[i]
                                this.vsData.push(item)
                            }
                            
                            this.vsData.forEach(item => {
                                item.create_time = getTimeDate(item.create_time)
                            });
                        }
                    }else{
                        if(res.data == 'notlogin'){
                            this.$notify({
                                title: '提示',
                                message: '未登录，请先登陆',
                                type: 'error'
                            })

                            this.$router.push('/login')


                        }
                    }
                })
       
            
        },
        handleCurrentChange(val){
            let data = {
                pageNum: val,
                pageSize: 20
            }
            this.GetList(data)
        },
        allUrlToX(val,id){
            if(val == 1){
                this.$router.push({
                    path: '/MyInquiryInfo',
                    query: {
                        id: id
                    }
                })
            }else if(val == 2){
                this.$router.push({
                    path: '/MyInquiryCompany', //报价
                    query: {
                        id: id
                    }
                })
            }
        }
    },
    mounted(){
        let data = {
            pageNum: 1,
            pageSize: 20
        }
        this.GetList(data)
    }
}
</script>

<style scoped lang="scss">
.inquiry_main{
    background: #fff;
    width: 1190px;
    padding-bottom: 30px;
    min-height: calc(100vh - 215px);
    margin: 45px auto;
    position: relative;
    .current{
       
        position: absolute;
        top: 10px;
        left: 10px;
        font-size: 17px;
        color: #333;
        span{
            font-size: 17px;
            cursor: pointer;
            color: #666666;
        }
    }
    .inquiry_info{
        width: 1180px;
        margin: 25px auto;
        padding: 10px 0px;
        position: relative;
        .vstips{
            text-align: center;
            padding: 20px 0;
            font-size: 18px;
            color: #666666;
        }
        .vsList-normal{
            margin-top: 10px;
            padding: 10px 40px 20px 40px;
            border-bottom: 0.5px solid #f2f2f2;
           
            .vstitle{
                font-size: 18px;
                color: #333;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .vsintro{
                    font-size: 16px;
                    color: #666666;
                }
            }
            .vsflags{
                text-align: right;
                margin-top: 20px;
            }
        }
        .pagination{
            text-align: right;
        }
    }
}
        
</style>